export const getListSort = ({ key }) => {
    // Something in SPA adds a trailing / to window.location.pathname. Easier to fix here.
    const _key = key.replace(/\/$/, '');
    let sticky;
    try { sticky = JSON.parse(localStorage.getItem('sticky_list_sort')) } catch (_) {};
    return sticky?.[_key];
};

export const setListSort = ({ field, key, order }) => {
    // Something in SPA adds a trailing / to window.location.pathname. Easier to fix here.
    const _key = key.replace(/\/$/, '');
    let sticky;
    try { sticky = JSON.parse(localStorage.getItem('sticky_list_sort')) } catch (_) {};
    if (!sticky) sticky = {};
    sticky[_key] = { field, order };
    localStorage.setItem('sticky_list_sort', JSON.stringify(sticky));
};
